import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.editProjectRelatedProductsSection.title, 'Produits liés'),
  addProduct: () => __(translations.editProjectRelatedProductsSection.addProduct, 'Ajouter un produit'),
  product: () => __(translations.editProjectRelatedProductsSection.product, 'Produit'),
  noCollection: () => __(translations.editProjectRelatedProductsSection.noCollection, 'Sans collection'),
};
